import { DataForm } from 'components/formik_inputs';
import DynamicSelect from 'components/formik_inputs/custom-inputs/DynamicSelect';
import { Formik } from 'formik';
import React, { useState } from 'react';
import CurriculumInputSelect from '../../../components/formik_inputs/custom-inputs/CurriculumInputSelect';
import { fetchGrids } from 'services/options_services';
import ListFilter from '../../../components/common/list-filter/ListFilter';
const CurricularEquivalenceFilter = ({ ...props }) => {
  const handleFormChange = (e) => {
    props.filters(e);
  };

  return (
    <ListFilter>
      <Formik initialValues={{}}>
        {({ formik, values }) => (
          <>
            <CurriculumInputSelect />
            <DynamicSelect
              label="Grade Disciplina"
              placeholder="Selecione um curriculo para filtrar"
              name="grid_discipline"
              fetchFunction={fetchGrids}
              waitPreSelection={!values?.curriculum}
              searchParams={{
                curriculum: values?.curriculum?.id,
              }}
              getOptionValue={(d) => d.id}
              getOptionLabel={(d) => d.name}
              onChange={(e) => handleFormChange({ discipline: e?.id })}
            />
          </>
        )}
      </Formik>
    </ListFilter>
  );
};

export default CurricularEquivalenceFilter;
